export default __webpack_public_path__ + "static/media/Thief's Straps of the Swift Return.5ad0a287.jpg";